import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import StatsNumber from '../StatsNumber'

function NegativeBuyerRatings({ count, statsNumber }) {
  const tooltipContent = (
    <div>
      Take action and fix the ratings by working with the customer!
      Go to Product Feedback section in inbox, talk to the buyer and
      turn the negative into a positive.
      <a href="/profile/inbox" target="_blank" className="btn btn-primary btn-block u-mt10">Take me to inbox</a>
    </div>
  )

  return (
    <div>
      {count === 0
        ? statsNumber
        : (
          <Tooltip
            tooltipClassName="tooltip--negative-ratings"
            id="dashboard__negative-ratings"
            content={tooltipContent}
            delayHide={300}
          >
            {statsNumber}
          </Tooltip>
        )
      }
    </div>
  )
}

NegativeBuyerRatings.propTypes = {
  count: PropTypes.number.isRequired,
  statsNumber: PropTypes.object.isRequired,
}

export default NegativeBuyerRatings
